module.exports = __webpack_public_path__ + "img/2.3c84948b.png";